module.exports = __webpack_public_path__ + "static/media/Arrow-Circle-active.d0732ca0.svg";